const Login = () => <>Login</>;

export default Login;
